import { convertISOToDateFormat } from '../../../../util/timezone';

export default {
  defaultProperties: {
    render: (text) => (text ? text : '-')
  },
  customProperties: {
    anticipatedSettlementDate: {
      render: (text) => (text ? convertISOToDateFormat(text) : '-')
    },
    accountClosedDate: {
      render: (text) => (text ? convertISOToDateFormat(text) : '-')
    },
    lastPaymentDate: {
      render: (text) => (text ? convertISOToDateFormat(text) : '-')
    },
    loanFirstDisbursementDate: {
      render: (text) => (text ? convertISOToDateFormat(text) : '-')
    },
    nextInstallmentDate: {
      render: (text) => (text ? convertISOToDateFormat(text) : '-')
    },
    accountOpenDate: {
      render: (text) => (text ? convertISOToDateFormat(text) : '-')
    }
  }
};
